import { Alert, Button } from "@mui/material";
import { usePortraitsTranslator } from "../i18n/translator";
import { CardPreview } from "./CardPreview";
import { FlowPanel, StepProps } from "./FlowPanel";
import { PortraitFlow } from "./usePortraitFlow";

const CardNotice = ({ flow }: { flow: PortraitFlow }) => {
  const translator = usePortraitsTranslator();

  if (flow.notice === "submitted") {
    return <Alert severity="success">{translator("submitted")}</Alert>;
  }
  if (flow.notice) {
    return <Alert severity="info">{translator(flow.notice)}</Alert>;
  }
  if (!flow.hasUnsavedChoice) {
    return <Alert severity="success">{translator("savedForYourCards")}</Alert>;
  }
  return null;
};

export const CardStep = ({ portrait, name, flow, headingRef }: StepProps) => {
  const translator = usePortraitsTranslator();
  const { shownChoice, busy } = flow;
  const christmasImageUrl =
    shownChoice !== "christmasImage"
      ? undefined
      : flow.hasUnsavedChoice
        ? portrait.christmasImage?.imageUrl
        : portrait.choice?.kind === "christmasImage"
          ? portrait.choice.imageUrl
          : undefined;

  return (
    <FlowPanel
      name={name}
      flow={flow}
      headingRef={headingRef}
      stepTitle={translator("cardTitle")}
      hint={translator(
        shownChoice === "photoOnly"
          ? "cardHintPhotoOnly"
          : flow.hasUnsavedChoice
            ? "cardHintUnsaved"
            : "cardHintSaved",
      )}
      picture={
        <CardPreview
          photoUrl={portrait.cutout?.imageUrl}
          christmasImageUrl={christmasImageUrl}
          autoFlip={!busy}
        />
      }
      status={flow.choose.isPending ? translator("saving") : undefined}
      error={
        flow.choose.isError
          ? translator("unknownErrorTryAgainLater")
          : undefined
      }
      notice={<CardNotice flow={flow} />}
      actions={
        <>
          {flow.hasUnsavedChoice && (
            <Button
              variant="contained"
              fullWidth
              disabled={busy}
              onClick={flow.submit}
            >
              {translator("submitCard")}
            </Button>
          )}
          <Button
            variant="outlined"
            fullWidth
            disabled={busy}
            onClick={() => flow.open("photo")}
          >
            {translator("changePhoto")}
          </Button>
          <Button
            variant="outlined"
            fullWidth
            disabled={busy}
            onClick={flow.openChristmasImage}
          >
            {translator(
              shownChoice === "photoOnly"
                ? "addChristmasImage"
                : "changeChristmasImage",
            )}
          </Button>
          {shownChoice !== "photoOnly" && (
            <Button
              fullWidth
              disabled={busy}
              onClick={flow.goWithoutChristmasImage}
            >
              {translator("noChristmasImageThanks")}
            </Button>
          )}
        </>
      }
    />
  );
};
